import { RefineKbar } from "@pankod/refine-kbar";

export const OffLayoutArea: React.FC = () => {
  return <RefineKbar />;
};
